














import Vue from 'vue';
import VeHistogram from 'v-charts/lib/histogram.common';
import customerClient from '../../../apis';
import 'echarts/lib/component/title';
import customerVuex from '../../../vuex/common';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    VeHistogram,
  },
  data() {
    return {
      loadingSubscribeData: true,
      chartData: {
        columns: ['time', 'count'],
        rows: [],
      },
      title: {
        text: '关注时长',
        left: 'center',
        textStyle: {
          color: '#000',
          fontSize: 14,
        },
      },
      legend: {
        show: false,
      },
      chartTheme: {
        valueAxis: {
          splitLine: {
            lineStyle: {
              color: '#cccccc',
              type: 'dotted',
            },
          },
        },
      },
      chartSettings: {
        metrics: ['count'],
        labelMap: {
          count: '用户数',
        },
        label: {
          show: true,
          textStyle: {
            fontSize: '12',
            color: '#000',
          },
          position: 'top',
        },
      },
      chartExtend: {
        tooltip: {
          show: false,
        },
        series: {
          barWidth: 20,
          barGap: '100%',
        },
        xAxis: {
          axisLine: {
            lineStyle: {
              color: '#ccc',
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          axisLine: {show: false}, 
        },
      },
      colors: ['#59CB74'],
    };
  },
  methods: {
    getSubscribeData() {
      customerClient.getSubscribeGroup(this.customerState.customerQuery).success((r) => {
        this.chartData.rows = [ 
          { time: '一周', count: r.oneWeek},
          { time: '一个月', count: r.oneMonth},
          { time: '三个月', count: r.threeMonth},
          { time: '半年', count: r.halfYear},
          { time: '一年', count: r.oneYear},
          { time: '两年', count: r.twoYear},
          { time: '三年', count: r.threeYear},
          { time: '超过三年', count: r.more}];
        this.loadingSubscribeData = false;
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
  },
  mounted() {
    this.getSubscribeData();
  },
});

